import axios from "axios";
import routes from "../app/routes";

export const multiFilterActions = {
  loadFilters: (dispatch) => {
    axios.get(routes.api.coaches.filters).then((resp) => {
      dispatch({ type: "loadFilters", filters: resp.data.data });
    });
  },
  countSelectedItems: (category, state) => {
    let countSelected = 0;
    state.filters.forEach((wrapper) => {
      if (wrapper.category == category) {
        wrapper.filters.forEach((group) => {
          countSelected += state.selected[group.subcategory].length;
        });
      }
    });
    return countSelected;
  },
  setCoachName: (dispatch, coachName) => {
    dispatch({
      type: "setCoachName",
      coachName: coachName,
    });
  },
  setShowSelectedOnly: (dispatch, status) => {
    dispatch({
      type: "setShowSelectedOnly",
      status: status,
    });
  },
  setChecked: (dispatch, subcategory, value, state) => {
    dispatch({
      type: "setChecked",
      subcategory: subcategory,
      value: value,
      state: state,
    });
  },
  selectSubCategory: (dispatch, subcategory) => {
    dispatch({ type: "selectSubCategory", subcategory: subcategory });
  },
  deselectSubCategory: (dispatch, subcategory) => {
    dispatch({ type: "deselectSubCategory", subcategory: subcategory });
  },
  selectCategory: (dispatch, category) => {
    dispatch({ type: "selectCategory", category: category });
  },
  deselectCategory: (dispatch, category) => {
    dispatch({ type: "deselectCategory", category: category });
  },
  clearAllFilters: (dispatch) => {
    dispatch({ type: "clearAllFilters" });
  },
};
